export default __webpack_public_path__ + "static/media/disable-white.04442e03.svg";